// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { Application } from "@hotwired/stimulus"
import ContentLoader from 'stimulus-content-loader'

const application = Application.start()

application.register('content-loader', ContentLoader)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

import HelloController from "./hello_controller"
import ContentLoaderController from "./content_loader_controller"
import NexusDiagnosticInfiniteScrollController from "./nexus_diagnostic_infinite_scroll_controller"
import ClickableCsvValueController from "./clickable_csv_value_controller"
import AutosubmitController from "./autosubmit_controller"
import NexusUploadPreviewColumnValuesController from "./nexus_upload_preview_column_values_controller"
import ShowTableButtonController from "./show_table_button_controller"
import ReadMoreController from "./read_more_controller"
import FormToggleController from "./form_toggle_controller"
import ToggleTableRowsController from "./toggle_table_rows_controller"
import SelectAllController from "./select_all_controller"
import TransactionProcessorListenerController from "./transaction_processor_listener_controller"
import ClickableTableRowController from "./clickable_table_row_controller"
import AutoSaveController from "./auto_save_controller"
import QuickLoadController from "./quick_load_controller"

application.register("toggle-table-rows", ToggleTableRowsController)
application.register("clickable-csv-value", ClickableCsvValueController)
application.register("read-more", ReadMoreController)
application.register("nexus-diagnostic-infinite-scroll", NexusDiagnosticInfiniteScrollController)
application.register("content-loader", ContentLoaderController)
application.register("autosubmit", AutosubmitController)
application.register("hello", HelloController)
application.register("nexus-upload-preview-column-values", NexusUploadPreviewColumnValuesController)
application.register("show-table-button", ShowTableButtonController)
application.register("form-toggle", FormToggleController)
application.register("select-all", SelectAllController)
application.register("transaction-processor-listener", TransactionProcessorListenerController)
application.register("clickable-table-row", ClickableTableRowController)
application.register("auto-save", AutoSaveController)
application.register("quick-load", QuickLoadController)

window.addEventListener('pageshow', event => {
    application.controllers.forEach(controller => {
        if (typeof controller.pageShow === 'function') {
            controller.pageShow(event.persisted)
        }
    })
})
